import React from "react";
import { AppBar, Button, Grid } from "@mui/material";
import { LogoutIcon } from "../Icons/Icons";

export function AccountTopNav(props) {
  return (
    <AppBar position="fixed" style={{ backgroundColor: "white" }} elevation={0}>
      <Grid container style={{ padding: "15px", paddingRight: "0px" }}>
        <Grid item xs={6} md={3} style={{ paddingTop: "2px" }}>
          <img
            src={require("../Images/logo.png")}
            style={{ width: "95px" }}
            alt="logo"
          />
        </Grid>
        <Grid item md={6}></Grid>
        <Grid
          item
          xs={3}
          md={1}
          style={{
            textAlign: "right",
            display: "flex",
            paddingRight: "8px",
            justifyContent: "right",
            alignItems: "right",
            cursor: "pointer",
            paddingTop: "12px",
          }}
        ></Grid>
        <Grid
          item
          md={1}
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {props.loading === false && (
            <Button
              variant="contained"
              style={{
                backgroundColor: "#f5f5f5",
                color: "#5F6165",
                boxShadow: "none",
                textTransform: "none",
              }}
              onClick={() => props.logOut()}
              startIcon={<LogoutIcon color={"#5F6165"} />}
            >
              Logout
            </Button>
          )}
        </Grid>

        <Grid
          item
          xs={3}
          md={1}
          style={{
            paddingLeft: "8px",
            textAlign: "left",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            alt="profile"
            width={"40px"}
            height={"40px"}
            src={require("../Images/testuser.png")}
            style={{ borderRadius: "100%" }}
          />
        </Grid>
      </Grid>
    </AppBar>
  );
}
